import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'loyal-react'

const ActionButton = ({
  isLoading,
  hasSuccess,
  hasError,
  errorText,
  successText,
  text,
  AddItemCart,
  className,
  iconName,
  noIcon
}) => (
  <Button
    className={`btn btn-sm txt-uppercase txt-center ${className} ${
      hasSuccess
        ? 'btn-cart-success btn-icon'
        : hasError
          ? 'cart-done btn-featured btn-sm btn-cart-error btn-icon'
          : ''}`}
    disabled={isLoading}
    loading={isLoading}
    onClick={AddItemCart}
    iconName={!noIcon && (hasSuccess
      ? 'icon_check_circle color-success'
      : hasError
        ? 'icon_close_circle color-error'
        : iconName)}
    text={`${isLoading
      ? null
      : hasSuccess
        ? successText
        : hasError
          ? errorText
          : text}`}
  />
)

ActionButton.propTypes = {
  text: PropTypes.string,
  isLoading: PropTypes.bool,
  className: PropTypes.string,
  errorText: PropTypes.string,
  successText: PropTypes.string,
  hasError: PropTypes.bool,
  hasSuccess: PropTypes.bool,
  iconName: PropTypes.string,
  noIcon: PropTypes.bool,
  AddItemCart: PropTypes.func
}

export default ActionButton



// WEBPACK FOOTER //
// ./src/Shared/Button/ActionButton.js